import { render, staticRenderFns } from "./CognniLabels.vue?vue&type=template&id=10fb832d&"
import script from "./CognniLabels.vue?vue&type=script&lang=ts&"
export * from "./CognniLabels.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports